'use client';

import { usePathname } from 'next/navigation';
import { Box } from '@mui/material';
import { AdminHeader } from './AdminHeader';

const authRoutes = ['/login', '/2fa'];

function isAuthRoute(pathname: string): boolean {
  const stripped = pathname.replace(/^\/(en|he)/, '') || '/';
  return authRoutes.some((route) => stripped.startsWith(route));
}

export function AdminShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const showHeader = pathname ? !isAuthRoute(pathname) : false;

  if (!showHeader) {
    return <>{children}</>;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AdminHeader />
      <Box component="main" sx={{ flex: 1 }}>
        {children}
      </Box>
    </Box>
  );
}
